export const GET_NOTE_LIST_SUCCESS = 'GET_NOTE_LIST_SUCCESS';
export const getNoteListSuccess = response => ({
  type: GET_NOTE_LIST_SUCCESS,
  payload: {
    response,
  },
});

export const GET_NOTE_LIST_ERROR = 'GET_NOTE_LIST_ERROR';
export const getNoteListError = error => ({
  type: GET_NOTE_LIST_ERROR,
  payload: {
    error,
  },
});

export const CREATE_NOTE_ITEM_SUCCESS = 'CREATE_NOTE_ITEM_SUCCESS';
export const createNoteItemSuccess = response => ({
  type: CREATE_NOTE_ITEM_SUCCESS,
  payload: {
    response,
  },
});

export const CREATE_NOTE_ITEM_ERROR = 'CREATE_NOTE_ITEM_ERROR';
export const createNoteItemError = error => ({
  type: CREATE_NOTE_ITEM_ERROR,
  payload: {
    error,
  },
});

export const DELETE_NOTE_ITEM_SUCCESS = 'DELETE_NOTE_ITEM_SUCCESS';
export const deleteNoteItemSuccess = id => ({
  type: DELETE_NOTE_ITEM_SUCCESS,
  payload: {
    id,
  },
});

export const TOGGLE_NOTE_LIST_LOADING = 'TOGGLE_NOTE_LIST_LOADING';
export const toggleNoteListLoading = isLoading => ({
  type: TOGGLE_NOTE_LIST_LOADING,
  payload: { isLoading },
});

export const EDIT_NOTE_ITEM = 'EDIT_NOTE_ITEM';
export const editNoteItem = id => ({
  type: EDIT_NOTE_ITEM,
  payload: { id },
});

export const CANCEL_EDIT_NOTE_ITEM = 'CANCEL_EDIT_NOTE_ITEM';
export const cancelEditNoteItem = () => ({
  type: CANCEL_EDIT_NOTE_ITEM,
});

export const UPDATE_NOTE_ITEM_SUCCESS = 'UPDATE_NOTE_ITEM_SUCCESS';
export const updateNoteItemSuccess = response => ({
  type: UPDATE_NOTE_ITEM_SUCCESS,
  payload: {
    response,
  },
});
